module.exports = __webpack_public_path__ + "static/media/members.13d34ffd.jpg";